export default "__VITE_ASSET__il66TASh__"